import { HStack, IconButton, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { Icon } from "semente-js";
import { Props } from "./types";

const IndicatorTypeList: React.FC<Props> = ({
  indicatorTypes,
  handleEditIndicatorType,
  handleReorder,
}) => {
  return (
    <VStack w={"full"} spacing={"16px"}>
      {indicatorTypes
        .sort((a, b) => a.order - b.order)
        .map((indicatorType, index) => (
          <HStack
            key={indicatorType.id}
            w={"full"}
            px={"16px"}
            border={"1px solid"}
            borderColor={"Gray.$300"}
            borderRadius={"8px"}
            justifyContent={"space-between"}
            bg={"white"}
          >
            <HStack >
              <VStack spacing={0}>
                <IconButton
                  aria-label="Move up"
                  icon={<Icon name="chevron-up-circle" color="#141414" size="20px" />}
                  size="xs"
                  isDisabled={index === 0}
                  onClick={() => handleReorder(indicatorType.id, "up")}
                  variant="ghost"
                />
                <Text>#{indicatorType.order}</Text>
                <IconButton
                  aria-label="Move down"
                  icon={<Icon name="chevron-down-circle" color="#141414" size="20px" />}
                  size="xs"
                  isDisabled={index === indicatorTypes.length - 1}
                  onClick={() => handleReorder(indicatorType.id, "down")}
                  variant="ghost"
                />
              </VStack>
              <VStack alignItems={"flex-start"} spacing={0}>
                <Text fontSize={"L_md"} fontWeight={600} color={"Gray.$800"}>
                  {indicatorType.name}
                </Text>
                <Text fontSize={"L_sm"} color={"Gray.$600"}>
                  {indicatorType.is_active ? "Ativo" : "Inativo"}
                </Text>
              </VStack>
            </HStack>

            <HStack>
              <IconButton
                aria-label="Edit"
                icon={<Icon name="pen-solid" color="#141414" size="16px" />}
                variant="ghost"
                onClick={() => handleEditIndicatorType(indicatorType)}
              />
            </HStack>
          </HStack>
        ))}
    </VStack>
  );
};

export default IndicatorTypeList;

